<template>
    <div @click.self="switchBoard" class="choose-number">
        <!-- <h6
            @click.self="switchBoard"
        >
            {{ t.ChooseNumber }}
        </h6> -->
        <div
            @click.self="switchBoard"
        >
            <div @click.self="switchBoard">
                <div
                    @click.self="switchBoard"
                    class="bg-[#032144] text-btnPrimary text-[10px] mb-2 font-bold w-[114px] mx-auto text-center py-1 px-2 rounded-t-lg"
                >
                    {{ t.ChooseNumber }}
                </div>
                <div class="choose-content">
                    <div class="choose-item">
                        <span class="text-[#ffffff4d]">{{ t.Low }}</span>
                        <input
                            :min="lowInputMin"
                            :max="config.max"
                            class="w-full font-bold bg-[#031730FF] outline-none text-center"
                            maxlength="4"
                            inputmode="numeric"
                            @keypress="onlyNumberPress"
                            @input="onlyNumberChange"
                            :value="minModelValue"
                            @blur="onMinValueChange"
                            type="number"
                        />
                    </div>
                    <div @click="switchBoard" class="px-2">
                        <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M0.530188 3.57011C0.224313 3.38658 0.224312 2.94328 0.530187 2.75975L3.8644 0.759228C4.17934 0.570264 4.58001 0.797123 4.58001 1.1644V5.16546C4.58001 5.53274 4.17934 5.75959 3.8644 5.57063L0.530188 3.57011Z"
                                fill="#297FE5"
                            ></path>
                            <path
                                d="M2.69103 3.16493C2.69103 2.64301 3.11413 2.2199 3.63605 2.2199H10.2512C10.7731 2.2199 11.1962 2.64301 11.1962 3.16493C11.1962 3.68685 10.7731 4.10995 10.2512 4.10995H3.63605C3.11413 4.10995 2.69103 3.68685 2.69103 3.16493Z"
                                fill="#297FE5"
                            ></path>
                            <path
                                d="M11.4698 8.42989C11.7757 8.61342 11.7757 9.05672 11.4698 9.24024L8.1356 11.2408C7.82066 11.4297 7.41999 11.2029 7.41999 10.8356L7.41999 6.83454C7.41999 6.46726 7.82066 6.2404 8.1356 6.42937L11.4698 8.42989Z"
                                fill="#297FE5"
                            ></path>
                            <path
                                d="M9.30819 8.83507C9.30819 9.35699 8.88509 9.78009 8.36316 9.78009L1.748 9.78009C1.22607 9.78009 0.802973 9.35699 0.802973 8.83507C0.802973 8.31315 1.22607 7.89004 1.748 7.89004L8.36316 7.89005C8.88509 7.89005 9.30819 8.31315 9.30819 8.83507Z"
                                fill="#297FE5"
                            ></path>
                        </svg>
                    </div>

                    <div class="choose-item">
                        <span class="text-[#ffffff4d]">{{ t.High }}</span>
                        <input
                            :min="config.min"
                            :max="highInputMax"
                            class="flex w-full font-bold bg-[#031730FF] outline-none text-center"
                            maxlength="4"
                            inputmode="numeric"
                            @keypress="onlyNumberPress"
                            @input="onlyNumberChange"
                            :value="maxModelValue"
                            @blur="onMaxValueChange"
                            type="number"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import useTranslation from '~/i18n/useTransLation';
import { onlyNumberChange, onlyNumberPress } from '@/utils/input';
const t = useTranslation();

const props = defineProps({
    maxModelValue: {
        type: Number,
        required: true,
    },
    minModelValue: {
        type: Number,
        required: true,
    },
    is_in: {
        type: Boolean,
        required: true,
    },
    config: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits(['update:maxValue', 'update:minValue', 'isInputNumber']);

const maxScope = computed(() =>
    props.is_in ? props.config.maxScopeIn : props.config.maxScopeOut,
);
const highInputMax = computed(() =>
    Math.min(props.config.max, Number(props.minModelValue) + maxScope.value),
);
const lowInputMin = computed(() =>
    Math.max(props.config.min, Number(props.maxModelValue) - maxScope.value),
);

const parseValue = (raw: string, fallback: number) => {
    const value = Number(raw);
    return raw === '' || !Number.isFinite(value) ? fallback : value;
};

const onMaxValueChange = ($event: any) => {
    const min = Number(props.minModelValue);
    let value = parseValue($event.target.value, props.maxModelValue);
    value = Math.min(Math.max(value, props.config.min), highInputMax.value);

    if (!props.is_in && value - min < props.config.minGap) {
        value = Math.min(min + props.config.minGap, props.config.max);
    } else if (value < min) {
        value = props.maxModelValue;
    }

    $event.target.value = value;
    emit('update:maxValue', value);
};

const onMinValueChange = ($event: any) => {
    const max = Number(props.maxModelValue);
    let value = parseValue($event.target.value, props.minModelValue);
    value = Math.max(Math.min(value, props.config.max), lowInputMin.value);

    if (!props.is_in && max - value < props.config.minGap) {
        value = Math.max(max - props.config.minGap, props.config.min);
    } else if (value > max) {
        value = props.minModelValue;
    }

    $event.target.value = value;
    emit('update:minValue', value);
};

const switchBoard = () => {
    emit('isInputNumber', false);
};
</script>

<style scoped lang="scss">
.bg {
    clip-path: polygon(6% 0, 100% 0, 100% 8%, 100% 89%, 92% 100%, 0 100%, 0 100%, 0 11%);
    border-radius: 5px;
}
.choose-number {
    cursor: pointer;
    align-items: center;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    h6 {
        background: #032144;
        border-radius: 4px 4px 0 0;
        color: #2283f6;
        font-size: 10px;
        font-style: normal;
        font-weight: 700;
        line-height: 12px;
        padding: 4px 6px 0;
        text-align: center;
        transform: translateY(2px);
        width: 114px;
        letter-spacing: -.02em;
        margin-bottom: 1rem;
        margin-top: 0;
    }
}

.choose-content {
    background-image: url('@/assets/svg/conterBig.svg');
    height: 56px;
    padding: 8px;
    width: 200px;
    background-repeat: no-repeat;
    align-items: center;
    display: flex;
    justify-content: space-between;
}
.choose-item {
    background-image: url('@/assets/svg/conter.svg');
    display: flex;
    flex-direction: column;
    height: 40px;
    justify-content: center;
    max-width: 91px;
    width: 100%;
    align-items: center
}
</style>
